import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'lab-order-templates';

export interface OrderTemplateTest {
    testId: string;
    testName: string;
    price: number;
}

export interface OrderTemplate {
    id: string;
    name: string;
    tests: OrderTemplateTest[];
    referenceDoctor?: string;
    createdAt: string;
}

const readTemplates = (): OrderTemplate[] => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const writeTemplates = (templates: OrderTemplate[]) => {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(templates)); } catch { /* storage unavailable */ }
};

export function useOrderTemplates() {
    const [templates, setTemplates] = useState<OrderTemplate[]>(() => readTemplates());

    useEffect(() => { writeTemplates(templates); }, [templates]);

    const saveTemplate = useCallback((name: string, tests: OrderTemplateTest[], referenceDoctor?: string) => {
        const template: OrderTemplate = {
            id: `tmpl-${Date.now()}-${Math.random().toString(16).slice(2)}`,
            name,
            tests,
            referenceDoctor,
            createdAt: new Date().toISOString(),
        };
        setTemplates(prev => [template, ...prev]);
        return template;
    }, []);

    const deleteTemplate = useCallback((id: string) => {
        setTemplates(prev => prev.filter(t => t.id !== id));
    }, []);

    return { templates, saveTemplate, deleteTemplate };
}
